import React from "react";
import LiveRegion from "../components/UI/LiveRegion";

const PrivateLayout = (WrappedComponent) => (props) => {
    return (
        <React.Fragment>
            <LiveRegion />
            <WrappedComponent {...props} />
        </React.Fragment>
    )
}
export default PrivateLayout;
